import { render, staticRenderFns } from "./EventTypeView.vue?vue&type=template&id=3050c05c&scoped=true"
import script from "./EventTypeView.vue?vue&type=script&lang=js"
export * from "./EventTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3050c05c",
  null
  
)

export default component.exports